<mat-progress-spinner
    class="spinner"
    mode="indeterminate"
    *ngIf="!dataSource">
</mat-progress-spinner>

<div class="buttons" *ngIf="showHeader && group_rights?.create_lesson.is_access" [hidden]="!dataSource">
    <app-lessons-list-header></app-lessons-list-header>
</div>

<div class="filter-wrapper" [ngClass]="{'prepare-page': showHeader }">
    <mat-form-field [style.padding.px]="0" [style.marginRight.px]="35">
        <mat-label>Предмет</mat-label>
        <mat-select (valueChange)="changeSubject($event)">
            <mat-option *ngFor="let subject of subjects" [value]="subject">{{subject.title}}</mat-option>
        </mat-select>
    </mat-form-field>
    <ng-container *ngIf="showSchoolFilter">
        <mat-form-field [style.padding.px]="0" [style.marginRight.px]="35">
            <mat-label>Школа</mat-label>
            <mat-select (valueChange)="changeSchool($event)">
                <mat-option *ngFor="let school of schools" [value]="school">{{school.title}}</mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>

    <mat-form-field appearance="standard" class="lesson-filter">
        <mat-label>🔍 Поиск</mat-label>
        <input matInput (keyup)="applySearch($event)" [value]="filterValue">
    </mat-form-field>
</div>

<table mat-table matSort [hidden]="!dataSource" [dataSource]="dataSource" class="grid">
    <ng-container matColumnDef="lesson_number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-number">№</th>
        <td mat-cell *matCellDef="let lesson"
            (click)="editLesson(lesson)"
            class="column-number cell cell-first cell-number cell-number--{{getStatusClass(lesson.status)}}">
            {{lesson.lesson_number}}
            <span *ngIf="lesson?.is_smart_sprints" class="smart-sprint__indicator">.</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="student_class_title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-class">Класс</th>
        <td mat-cell *matCellDef="let lesson"
            (click)="editLesson(lesson)"
            class="column-number cell cell-class">
            {{lesson.student_class.title}}
        </td>
    </ng-container>

    <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-description">Описание</th>
        <td mat-cell *matCellDef="let lesson" (click)="editLesson(lesson)"
            class="cell cell-last cell-title">
            {{ lesson.title || '--------------------' }}
            <div *ngIf="lesson.remarks" class="lesson-remarks">{{ lesson.remarks }}</div>
        </td>
    </ng-container>

    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-date">Дата</th>
        <td mat-cell *matCellDef="let lesson" (click)="editLesson(lesson)"
            class="cell cell-date"> {{lesson.date | date:'dd.MM.yyyy'}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-status">Статус</th>
        <td mat-cell *matCellDef="let lesson;let i = index"
            (click)="updateStatus(lesson)"
            class="cell-status">
            <span class="status status-{{getStatusClass(lesson.status)}}">{{STATUS_LABELS.get(lesson.status)}}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="column-actions" ></th>
        <td mat-cell *matCellDef="let lesson" class="column-actions actions">
            <div class="actions-container">
                <app-svg-icon *ngIf="copyLessonAccess(lesson)"
                    [src]="copyIcon"
                    (click)="openCopyDialog(lesson)"
                    aria-hidden="true"
                    class="icon"></app-svg-icon>
                <app-svg-icon *ngIf="deleteLessonAccess(lesson)"
                    [src]="removeIcon"
                    aria-hidden="true"
                    (click)="openRemoveDialog(lesson)"
                    class="icon"></app-svg-icon>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="mat-row table-row {{getStatusClass(row.status)}}"></tr>
</table>

<mat-paginator
    [length]="dataSource?.data.length"
    [pageSize]="10"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons>
</mat-paginator>
